import { call, put, takeLatest } from "redux-saga/effects";
import * as api from "./api";
import * as actionTypes from "../ActionTypes";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

// 🔹 CHURCH PRAYERS
function* readChurchPrayersSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));

  const { data, callback } = action.payload;

  try {
    const response = yield call(api.readChurchPrayersAPI, data);

    yield put({
      type: actionTypes.READ_CHURCH_PRAYERS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response?.data || response });
  } catch (err) {
    const message = err.message || "Failed to fetch church prayers";

    yield put({
      type: actionTypes.READ_CHURCH_PRAYERS_FAIL,
      payload: message,
    });

    callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

// 🔹 CHANNEL PRAYERS
function* readChannelPrayersSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  const { data, callback } = action.payload;

  try {
    const response = yield call(api.readChannelPrayersAPI, data);

    yield put({
      type: actionTypes.READ_CHANNEL_PRAYERS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response?.data || response });
  } catch (err) {
    const message = err.message || "Failed to fetch channel prayers";

    yield put({
      type: actionTypes.READ_CHANNEL_PRAYERS_FAIL,
      payload: message,
    });

    callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

// 🔹 MINISTRY PRAYERS
function* readMinistryPrayersSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  const { data, callback } = action.payload;

  try {
    const response = yield call(api.readMinistryPrayersAPI, data);

    yield put({
      type: actionTypes.READ_MINISTRY_PRAYERS_SUCCESS,
      payload: response,
    });

    callback?.({ type: 1, data: response?.data || response });
  } catch (err) {
    const message = err.message || "Failed to fetch ministry prayers";

    yield put({
      type: actionTypes.READ_MINISTRY_PRAYERS_FAIL,
      payload: message,
    });

    callback?.({ type: 0, error: message });
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export default function* PrayersWatcherSaga() {
  yield takeLatest(
    actionTypes.READ_CHURCH_PRAYERS_REQUEST,
    readChurchPrayersSaga
  );
  yield takeLatest(
    actionTypes.READ_CHANNEL_PRAYERS_REQUEST,
    readChannelPrayersSaga
  );
  yield takeLatest(
    actionTypes.READ_MINISTRY_PRAYERS_REQUEST,
    readMinistryPrayersSaga
  );
}
